import React from 'react';
import { styled } from 'linaria/react';
import { Loader } from 'fronton-react';
import { FormRouter } from './form-router';
import { useGetCalculateData } from './hooks/use-get-calculate-data';

export const Content = () => {
  const { isLoaded } = useGetCalculateData();

  if (!isLoaded) {
    return (
      <LoadingContainer>
        <Loader />
      </LoadingContainer>
    );
  }

  return (
    <Container>
      <FormRouter />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0 32px var(--space-200) 32px;

  @media (--only-desktop) {
    padding: 0 var(--space-400) var(--space-200) var(--space-400);
  }

  @media (--only-tablet) {
    padding: 0 var(--space-400) var(--space-200) var(--space-400);
  }

  @media (--only-mobile) {
    padding: 0;
  }
`;

const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: calc(100vh - 112px);

  @media (--only-mobile) {
    height: calc(100vh - 48px);
  }
`;
